import './Lane.scss'

import React from 'react'
import PropTypes from 'prop-types'
import LaneHeader from './LaneHeader'
import LaneBody from './LaneBody'
import classNames from 'classnames'

const Lane = props => {
  const laneClasses = classNames({
    lane: true,
    'lane--empty': !props.tasks.length && !props.isAddingTask
  })

  return (
    <div className={laneClasses}>
      <LaneHeader
        scrollLeft={props.scrollLeft}
        name={props.lane.name}
        onAddCard={props.onCardAdd}
      />
      <LaneBody
        scrollTop={props.scrollTop}
        laneId={props.lane.id}
        tasks={props.tasks}
        onCardDrop={props.onCardDrop}
        isAddingTask={props.isAddingTask}
        taskAddCancel={props.taskAddCancel}
        taskAddSave={props.taskAddSave}
        setPlaceHolder={props.setPlaceHolder}
        isOver={props.placeHolder.laneId === props.lane.id}
        nextTaskId={props.placeHolder.laneId === props.lane.id ? props.placeHolder.nextTaskId : null} />
    </div>
  )
}

Lane.propTypes = {
  lane: PropTypes.object.isRequired,
  scrollLeft: PropTypes.number,
  scrollTop: PropTypes.number,
  tasks: PropTypes.array,
  onCardDrop: PropTypes.func,
  onCardAdd: PropTypes.func,
  isAddingTask: PropTypes.bool,
  taskAddCancel: PropTypes.func.isRequired,
  taskAddSave: PropTypes.func.isRequired,
  setPlaceHolder: PropTypes.func,
  placeHolder: PropTypes.object
}

export default Lane



// WEBPACK FOOTER //
// ./src/routes/Board/components/Lane.js